<div class="chips-container">
    <div class="chip" *ngFor="let i of chipsList">
        <span class="employee-name">{{ i.firstName }} {{ i.lastName }}</span>
        <i class="icon-cross_16px" (click)="removeChip(i)" (keydown.enter)="removeChip(i)" tabindex="0" role="button"></i>
    </div>
</div>
